import { renderThermalHeatmapToCanvas } from './renderHeatmap';

/**
 * 온도 그리드를 PNG로 내려받는다 (화면 줌/투명도와 무관하게 불투명 히트맵).
 *
 * @param {number[][]} dataMap
 * @param {{
 *   min?: number,
 *   max?: number,
 *   fileName?: string,
 *   alpha?: number
 * }} [options]
 * @returns {Promise<{ width: number, height: number, fileName: string }>}
 */
export async function downloadThermalHeatmapPng(dataMap, options = {}) {
  if (typeof document === 'undefined') {
    throw new Error('downloadThermalHeatmapPng requires a browser document');
  }
  const canvas = document.createElement('canvas');
  const result = renderThermalHeatmapToCanvas(canvas, dataMap, {
    scaleMode: 'relative',
    alpha: options.alpha != null ? options.alpha : 255
  });
  if (!result) {
    throw new Error('Failed to render thermal heatmap for download');
  }

  const fileName =
    options.fileName ||
    `thermal-heatmap-${result.width}x${result.height}.png`;

  const blob = await new Promise((resolve, reject) => {
    canvas.toBlob((b) => {
      if (b) resolve(b);
      else reject(new Error('canvas.toBlob returned null'));
    }, 'image/png');
  });

  const url = URL.createObjectURL(blob);
  try {
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    URL.revokeObjectURL(url);
  }

  return { width: result.width, height: result.height, fileName };
}
